import {
  Provider,
  QueryAndOutputs,
  WorkflowComponentCodeParams,
  WorkflowComponentParameterMode,
  WorkflowComponentParamType
} from '../types'

import { WorkflowComponent } from './common/workflowcomponent'

class ApiOutput extends WorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.output',
        group: 'Input/Output',
        title: 'API Output',
        description: `
          This component sets the node connected to it as output for API executions of the workflow.
        `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'mode',
          type: WorkflowComponentParamType.Selection,
          mode: WorkflowComponentParameterMode.Radio,
          title: 'Execution method',
          helper:
            'This setting controls the type of return value of the API call. Sync returns the result immediately, while Async returns a job ID.',
          options: [
            {
              value: 'sync',
              name: 'Sync',
              description: 'Returns the result data directly in the API response.',
              icon: 'sync'
            },
            {
              value: 'async',
              name: 'Async',
              description: 'Returns a job ID and table reference where the result will be available once complete.',
              icon: 'async'
            }
          ],
          value: 'async',
          default: 'async',
          allowExpressions: false,
          providers: [Provider.Snowflake, Provider.BigQuery]
        }
      ],
      []
    )
  }

  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.Snowflake, Provider.DatabricksRest]
  }

  async getFullCodeSnippet({ params }: WorkflowComponentCodeParams): Promise<QueryAndOutputs> {
    return {
      query: '',
      outputs: {}
    }
  }

  async getCode(_: WorkflowComponentCodeParams): Promise<QueryAndOutputs> {
    return {
      query: '',
      outputs: {}
    }
  }
}

export { ApiOutput }
